import React from 'react';
import { get } from 'lodash';
import { Document, Page, pdfjs } from 'react-pdf';
import { withRouter } from 'react-router-dom';
import ComponentWithToken from '../components/CompontentWithToken';
import { fetchStudent } from '../services/enrollment_services';
import { cpaVisited } from '../services/cpa_services';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class Cpa extends ComponentWithToken {
  state = {
    student: {},
    loading: true,
    fieds: {},
    cpaOptions: [],
  }

  componentDidMount() {
    this.fetchStudent();
  }

  fetchStudent = () => {
    fetchStudent(this.token)
    .then((response) => {
      this.setState({ student: response, loading: false });
    });
  }

  redirecionar = async () => {
    const cpf = (this.state.student.cpf || '').replace(/[.-]/g, '')
    const token = this.token
    cpaVisited(this.token).then(() => {
      window.location.href =  `https://cpa.feluma.org.br/cpa/index.xhtml?login=${cpf}&token=${token}`;
    });
  };

  render() {
    const { student } = this.state;
    return (
      <>
        <Document
          file={get(student, 'onboarding.cpa_pdf_url')}
          error="Não foi possível carregar o PDF."
          loading="Carregando..."
          noData="Não existe PDF."
          className="mb-5 pdf-viewer"
        >
          <Page pageNumber={1} />
        </Document>
        <div>
        </div>
        <div className="text-right">
          <div className="col-md-4 p-0 offset-md-8 col-sm-12">
            <div className="btn-actions">
              <button className="btn btn-primary" type="button" onClick={this.redirecionar}>Acessar a CPA</button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Cpa);
